import type { OmieBillingSlipIntegrationState } from '@bcube/shared';

export const billingSlipPhase = {
  NOT_STARTED: 'transient',
  RECEIVABLE_UNKNOWN: 'transient',
  RECEIVABLE_CREATED: 'transient',
  BILLING_SLIP_UNKNOWN: 'transient',
  BILLING_SLIP_GENERATED: 'success',
  RETRY_REQUIRED: 'error',
  CANCEL_REQUESTED: 'transient',
  CANCELED: 'canceled',
  INCONSISTENT: 'error',
} as const satisfies Record<OmieBillingSlipIntegrationState, string>;

export function paymentPollingInterval(
  status: string | undefined,
  elapsedMs: number,
): number | false {
  if (!status || ['APPROVED', 'CANCELED'].includes(status)) return false;
  // Keep observing long financial validations, with fewer requests after five minutes.
  return elapsedMs < 5 * 60_000 ? 5000 : 15000;
}
